import { ActionReducerMap } from "@ngrx/store";

import * as fromAccounts from "../features/accounts/store/accounts.reducer";
import * as fromAuth from "../features/auth/store/auth.reducer";
import * as fromClient from "../features/client/store/client.reducer";
import * as fromCountries from "../features/country/store/country.reducer";
import * as fromIntermediary from "../features/intermediary/store/intermediary.reducer";
import * as fromMessages from "../features/messages/store/messages.reducer";

export interface AppState {
  auth: fromAuth.AuthState;
  intermediary: fromIntermediary.IntermediaryState;
  client: fromClient.ClientState;
  country: fromCountries.CountryState;
  accounts: fromAccounts.AccountState;
  messages: fromMessages.MessageState;
}

export const APP_REDUCER: ActionReducerMap<AppState> = {
  auth: fromAuth.AUTH_REDUCER,
  intermediary: fromIntermediary.INTERMEDIARY_REDUCER,
  client: fromClient.CLIENT_REDUCER,
  country: fromCountries.COUNTRY_REDUCER,
  accounts: fromAccounts.ACCOUNTS_REDUCER,
  messages: fromMessages.MESSAGE_REDUCER,
};
